export default __webpack_public_path__ + "static/media/photo_gallery_12.535cdf60.png";